import { render, staticRenderFns } from "./CustomerOverview.vue?vue&type=template&id=45424bda"
import script from "./CustomerOverview.vue?vue&type=script&lang=ts"
export * from "./CustomerOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports